import type { QueryClient } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { mutationOptions } from '../../common/utils';
import { userAPIClient } from '../userAPIClient';
import { USER_QUERY_KEYS } from './keys';
import type {
  GetUserMeResponse,
  GetUserRequest,
  GetUserResponse,
  UpdateUserRequest,
  UpdateUserResponse,
} from './types';

export const USER_QUERIES = {
  getMe: () =>
    queryOptions<GetUserMeResponse>({
      queryKey: USER_QUERY_KEYS.getMe(),
      queryFn: () => userAPIClient.getMe(),
    }),
  getMeMutation: (queryClient: QueryClient) =>
    mutationOptions<GetUserMeResponse, Error, void>({
      mutationKey: USER_QUERY_KEYS.getMe(),
      mutationFn: () => userAPIClient.getMe(),
      onSuccess: (data) => {
        queryClient.setQueryData(USER_QUERY_KEYS.getMe(), data);
      },
    }),
  getUser: (params: GetUserRequest) =>
    queryOptions<GetUserResponse>({
      queryKey: USER_QUERY_KEYS.getUser(params.userId),
      queryFn: () => userAPIClient.getUser(params),
    }),
  getUserMutation: (queryClient: QueryClient) =>
    mutationOptions<GetUserResponse, Error, GetUserRequest>({
      mutationKey: USER_QUERY_KEYS.getUser(),
      mutationFn: (params: GetUserRequest) => userAPIClient.getUser(params),
      onSuccess: (data, variables) => {
        queryClient.setQueryData(USER_QUERY_KEYS.getUser(variables.userId), data);
      },
    }),
  updateUserMutation: () =>
    mutationOptions<UpdateUserResponse, Error, UpdateUserRequest>({
      mutationKey: USER_QUERY_KEYS.updateUser(),
      mutationFn: (payload: UpdateUserRequest) => userAPIClient.updateUser(payload),
    }),
};
